var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleWithOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    stroke: "currentColor",
    strokeWidth: 9,
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "60%",
    textAnchor: "middle",
    stroke: "#000000",
    fontSize: "3rem",
    fontFamily: "Roboto",
    strokeWidth: "0.1rem",
    dy: ".3rem"
  }, "1")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWithOne);
export default __webpack_public_path__ + "static/media/circleWithOne.24591d402c029904b5a7474db84b4d36.svg";
export { ForwardRef as ReactComponent };